import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../../firebase-config";
import { months } from "../../utils/months";
import ReactApexChart from "react-apexcharts";
import Card from "@mui/material/Card";

export default function MultiYearInflation({ yearValue }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = React.useState(true);

  const date = new Date();
  let firstYear;
  let lastYear;

  if (typeof yearValue === "number") {
    const currentYear = date.getFullYear();
    firstYear = currentYear;
    lastYear = currentYear - yearValue;
  } else if (yearValue === "all") {
    const currentYear = date.getFullYear();
    firstYear = currentYear;
    lastYear = 2010;
  }

  useEffect(() => {
    setLoading(true);
    async function getDocuments() {
      const q = query(
        collection(db, "inflation"),
        where("country", "==", "Kenya"),
        where("year", "<=", firstYear),
        where("year", ">=", lastYear),
        orderBy("year")
      );
      const allDocs = [];
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        allDocs.push(doc.data());
      });

      const allDateInflationRates = [];

      allDocs.sort(
        (a, b) =>
          a["year"] - b["year"] ||
          months.indexOf(a["month"]) - months.indexOf(b["month"])
      );

      allDocs.forEach((e) => {
        const month = e["month"];
        const year = e["year"];
        const inflationRate = e["inflation-rate"];

        const date = Date.parse(month + year);

        const dateInflationRate = [date, inflationRate];
        allDateInflationRates.push(dateInflationRate);
      });
      setData(allDateInflationRates);
      setLoading(false);
    }
    getDocuments();
  }, [firstYear, lastYear]);

  const options = {
    theme: {
      mode: "dark",
    },
    chart: {
      id: "area-datetime",
      type: "area",
      height: 400,
      zoom: {
        autoScaleYaxis: true,
      },
    },
    annotations: {},
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
      style: "hollow",
    },
    xaxis: {
      type: "datetime",
      min: new Date(`01 January ${lastYear}`).getTime(),
      tickAmount: 6,
    },
    tooltip: {
      x: {
        format: "dd MMM yyyy",
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        gradientToColors: ["rgba(27,27,251,1)"],
        shadeIntensity: 1,
        type: "vertical",
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
  };

  return loading ? (
    <h1>Loading</h1>
  ) : (
    <>
      {data.length > 0 ? (
        // <Card>
        <ReactApexChart
          options={options}
          series={[
            {
              name: "Inflation Rates",
              data: data,
            },
          ]}
          type="area"
        />
      ) : (
        // </Card>
        <h1>No Data Available</h1>
      )}
    </>
  );
}
